<template>
  <div class="nav" v-bind:class="{'safari__browser': isSafari == true}">
    <div class="nav__wrapper d-flex justify-content-between w-100">
      <router-link :to="{ name: 'pages', params: { kapitel:'00', pageid:'020' }}">
        <div class="nav__logo--wrapper">

          <img src="@/assets/global/shiseido_red.svg">
        </div>
      </router-link>
      <button class="hamburger hamburger--squeeze js-hamburger nav__toggler" :class="{'is-active': showMenu == true}" type="button" v-on:click="showMenu = !showMenu">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
      </button>
    </div>

    <div class="navigation position-absolute" :class="{'open': showMenu == true}">

      <div class="navigation--guide position-absolute d-none d-xl-block">
        <img src="@/assets/global/Miyuki_dori.png" class="img-fluid">
      </div>

      <div class="row w-100" v-if="menuActive == 1">
        <div class="col-12 col-lg-5 offset-lg-1 col-xl-3 offset-xl-3 d-flex align-items-center justify-content-end instructions__site">
          <div class="instructions__site--inner card h-100">

            <div class="card-body">
              <h2 class="text-uppercase font-black" v-on:click="openHowTo()" v-html="$t('MENU01')">How to ...</h2>

              <div class="instructions__wrapper" :class="{'open': howToOpen == true}">
                <div class="show__help-btn" v-on:click="menuActive = 3" v-html="$t('MENU02')" v-if="user.gift_active != 0">... win a prize</div>
                <div class="show__help-btn" v-on:click="menuActive = 4" v-html="$t('MENU03')">... navigate</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-5  col-xl-3  d-flex align-items-center justify-content-start menu__site">
          <div class="menu__site--inner card h-100">

            <div class="card-body">
              <h2 class="text-uppercase font-black" v-on:click="openDiscover()" v-html="$t('MENU04')">Discover</h2>
              <ul :class="{'open': discoverOpen == true}">
                <li :class="{'visited': worldStatus[0] == 1}" v-on:click="showMenu = !showMenu">
                  <router-link :to="{ name: 'pages', params: { kapitel:'01', pageid:'010', world: '1' }}" v-on:click="showMenu = !showMenu">
                    <span class="text-uppercase font-bold" v-html="$t('WORLD01_TEXT01')">  Ginza</span>
                  </router-link>
                </li>
                <li :class="{'visited': worldStatus[1] == 1, 'disabled': worldStatus[1] != 1}" v-on:click="showMenu = !showMenu">
                  <router-link :to="{ name: 'pages', params: { kapitel:'01', pageid:'020', world: '2' }}" v-on:click="showMenu = !showMenu">
                    <span class="text-uppercase font-bold" v-html="$t('SECTION02_TEXT03')"> Ueno Park</span>
                  </router-link>
                </li>
                <li :class="{'visited': worldStatus[2] == 1, 'disabled': worldStatus[2] != 1}" v-on:click="showMenu = !showMenu">
                  <router-link :to="{ name: 'pages', params: { kapitel:'01', pageid:'030', world: '3' }}">
                    <span class="text-uppercase font-bold" v-html="$t('WORLD03_TEXT01')">Asakusa</span>

                  </router-link>
                </li>

              </ul>
            </div>
            <div class="card-footer" :class="{'open': discoverOpen == true}">
              <div class="show__progress-btn" v-on:click="menuActive = 2" v-html="$t('MENU05')">show progress</div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid" v-if="menuActive == 2">
        <div class="row no-gutters">
          <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3 pt-0 pt-lg-5 pt-xl-0">
            <div class="card-deck" v-if="windowWidth > 992">
              <div class="card">
                <div class="card-body">
                  <h2 class="text-uppercase font-black" v-html="$t('WORLD01_TEXT01')">Ginza</h2>

                  <div class="badge__landmarks">
                    <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                    <p><span class="badge__status--check" :class="{'checked': progressStatus[0][index-1] == 1}" v-for="(index, item) in landmarksMax[0]"></span></p>
                  </div>
                  <div class="badge__quiz">
                    <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                    <p><span class="badge__status--check" :class="{'checked': quizSuccess[0] >= 1 || quizStatus[0] >= 3}" v-for="item in quizStatusMax[0]"></span></p>
                  </div>

                  <p class="badge__souvenir" ><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img v-if="quizSuccess[0] >= 1" src="@/assets/global/souvenir_ginza.svg" class="img-fluid"></p>
                  <p class="text-center mt-4" v-on:click="showMenu = !showMenu">
                    <router-link class="btn btn-red" :to="{ name: 'pages', params: { kapitel:'01', pageid:'010', world: '1' }}" v-on:click="showMenu = !showMenu" v-html="$t('MENU_VISIT')">
                      visit district
                    </router-link>
                  </p>

                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <h2 class="text-uppercase font-black"><span class="text-uppercase font-black" v-html="$t('WORLD02_TEXT01')">Ueno Park</span></h2>
                  <div class="badge__landmarks">
                    <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                    <p><span class="badge__status--check" :class="{'checked': progressStatus[1][index-1] == 1 }" v-for="(index, item) in landmarksMax[1]"></span></p>
                  </div>
                  <div class="badge__quiz">
                    <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                    <p><span class="badge__status--check" :class="{'checked': quizSuccess[1] >= 1 || quizStatus[1] >= 3}" v-for="item in quizStatusMax[1]"></span></p>
                  </div>
                  <p class="badge__souvenir" ><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img v-if="quizSuccess[1] >= 1" src="@/assets/global/souvenir_park.svg" class="img-fluid"></p>
                  <p class="text-center mt-4" v-on:click="showMenu = !showMenu">
                    <router-link v-if="worldStatus[1] == 1" class="btn btn-red" :to="{ name: 'pages', params: { kapitel:'01', pageid:'020', world: '2' }}" v-on:click="showMenu = !showMenu" v-html="$t('MENU_VISIT')">
                      visit district
                    </router-link>
                  </p>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <h2 class="text-uppercase font-black" v-html="$t('WORLD03_TEXT01')">Asakusa</h2>
                  <div class="badge__landmarks">
                    <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                    <p><span class="badge__status--check" :class="{'checked': progressStatus[2][index-1] == 1 }" v-for="(index, item) in landmarksMax[2]"></span></p>
                  </div>
                  <div class="badge__quiz">
                    <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                    <p><span class="badge__status--check" :class="{'checked': quizSuccess[2] >= 1 || quizStatus[2] >= 3}" v-for="item in quizStatusMax[2]"></span></p>
                  </div>

                  <p class="badge__souvenir" ><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img v-if="quizSuccess[2] >= 1" src="@/assets/global/souvenir_asakusa.svg" class="img-fluid"></p>
                  <p class="text-center mt-4" v-on:click="showMenu = !showMenu">
                    <router-link v-if="worldStatus[2] == 1" class="btn btn-red" :to="{ name: 'pages', params: { kapitel:'01', pageid:'030', world: '3' }}" v-on:click="showMenu = !showMenu" v-html="$t('MENU_VISIT')">
                      visit district
                    </router-link>
                  </p>

                </div>
              </div>
            </div>
            <Slick ref="slick" :options="slickOptions" v-else class="mobile__slider">
              <div class="card">
                <div class="card-body">
                  <h2 class="text-uppercase font-black" v-html="$t('WORLD01_TEXT01')">Ginza</h2>

                  <div class="badge__landmarks">
                    <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                    <p><span class="badge__status--check" :class="{'checked': progressStatus[0][index-1] == 1 }" v-for="(index, item) in landmarksMax[0]"></span></p>
                  </div>
                  <div class="badge__quiz">
                    <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                    <p><span class="badge__status--check" :class="{'checked': quizSuccess[0] >= 1 || quizStatus[0] >= 3}" v-for="item in quizStatusMax[0]"></span></p>
                  </div>

                  <p class="badge__souvenir" ><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img v-if="quizSuccess[0] >= 1" src="@/assets/global/souvenir_ginza.svg" class="img-fluid"></p>
                  <p class="text-center mt-4" v-on:click="showMenu = !showMenu">
                    <router-link class="btn btn-red" :to="{ name: 'pages', params: { kapitel:'01', pageid:'010', world: '1' }}" v-on:click="showMenu = !showMenu" v-html="$t('MENU_VISIT')">
                      visit district
                    </router-link>
                  </p>

                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <h2 class="text-uppercase font-black"><span class="text-uppercase font-black" v-html="$t('WORLD02_TEXT01')">Ueno Park</span></h2>
                  <div class="badge__landmarks">
                    <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                    <p><span class="badge__status--check" :class="{'checked': progressStatus[1][index-1] == 1 }" v-for="(index, item) in landmarksMax[1]"></span></p>
                  </div>
                  <div class="badge__quiz">
                    <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                    <p><span class="badge__status--check" :class="{'checked': quizSuccess[1] >= 1 || quizStatus[1] >= 3}" v-for="item in quizStatusMax[1]"></span></p>
                  </div>
                  <p class="badge__souvenir"><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img  v-if="quizSuccess[1] >= 1" src="@/assets/global/souvenir_park.svg" class="img-fluid"></p>
                  <p class="text-center mt-4" v-on:click="showMenu = !showMenu">
                    <router-link v-if="worldStatus[1] == 1" class="btn btn-red" :to="{ name: 'pages', params: { kapitel:'01', pageid:'020', world: '2' }}" v-on:click="showMenu = !showMenu" v-html="$t('MENU_VISIT')">
                      visit district
                    </router-link>
                  </p>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <h2 class="text-uppercase font-black" v-html="$t('WORLD03_TEXT01')">Asakusa</h2>
                  <div class="badge__landmarks">
                    <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                    <p><span class="badge__status--check" :class="{'checked': progressStatus[2][index-1] == 1 }" v-for="(index, item) in landmarksMax[2]"></span></p>
                  </div>
                  <div class="badge__quiz">
                    <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                    <p><span class="badge__status--check" :class="{'checked': quizSuccess[2] >= 1 || quizStatus[2] >= 3}" v-for="item in quizStatusMax[2]"></span></p>
                  </div>

                  <p class="badge__souvenir"><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img  v-if="quizSuccess[2] >= 1" src="@/assets/global/souvenir_asakusa.svg" class="img-fluid"></p>
                  <p class="text-center mt-4" v-on:click="showMenu = !showMenu">
                    <router-link v-if="worldStatus[2] == 1" class="btn btn-red" :to="{ name: 'pages', params: { kapitel:'01', pageid:'030', world: '3' }}" v-on:click="showMenu = !showMenu" v-html="$t('MENU_VISIT')">
                      visit district
                    </router-link>
                  </p>

                </div>
              </div>
            </Slick>

          </div>
        </div>
        <div class="row mt-6">
          <div class="col-12 col-lg-3 offset-lg-6 d-flex align-items-center justify-content-center">
            <p class="btn btn-red btn-red--chevron-left" v-on:click="menuActive = 1" v-html="$t('MENU_BACK')">back</p>
          </div>
        </div>
      </div>


      <div class="row w-100" v-if="menuActive == 3">
        <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3">
          <div class="card-deck" v-if="windowWidth > 992">
            <div class="card bg-red text-white">
              <div class="card-body d-flex align-items-end justify-content-center flex-column">
                <h2 class="text-uppercase font-black text-right" v-html="$t('MENU06')">How to win a prize</h2>
                <p class="btn btn-white btn-white--chevron-left" v-on:click="menuActive = 1" v-html="$t('MENU_BACK')">back</p>
              </div>
            </div>
            <div class="card">
              <div class="card-body d-flex align-items-center justify-content-center">
                <p v-html="$t('MENU07')">You have three attempts at each quiz. To get the Souvenir Pin you must reach 80% in each quiz, when you have all 3 pins you qualify for a gift</p>
              </div>
            </div>
            <div class="card">
              <div class="card-body d-flex align-items-center justify-content-center flex-column">
                <img src="@/assets/gifts/gift_ru.jpg" class="img-fluid" v-if="user.user.language == 'RU' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                <img src="@/assets/gifts/gift_uk.jpg" class="img-fluid" v-if="user.user.language == 'EN' && user.user.country != 'TX' && user.user.country !='ME' && user.is_limited_to_lounge != 1">
                <img src="@/assets/gifts/gift_es.jpg" class="img-fluid" v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                <img src="@/assets/gifts/gift_it.jpg" class="img-fluid" v-if="user.user.language == 'IT' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                <img src="@/assets/gifts/gift_bx.jpg" class="img-fluid" v-if="user.user.country == 'BX'">
                <img src="@/assets/gifts/gift_me.jpg" class="img-fluid" v-if="user.user.country == 'ME'">
                <img src="@/assets/gifts/gift_tr.jpg" class="img-fluid" v-if="user.user.country == 'TX'">
                <div v-if="user.user.language == 'RU' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">White Lucent</p>
                  <p class="mt-0 text-center font-size-18">Ночная крем-маска</p>
                </div>
                <div v-if="user.user.language == 'EN' && user.user.country != 'TX' && user.user.country != 'ME' && user.user.is_limited_to_lounge != 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Benefiance</p>
                  <p class="mt-0 text-center font-size-18">Wrinkle Smoothing Cream</p>
                </div>
                <div v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Essential Energy</p>
                  <p class="mt-0 text-center font-size-18">Moisturizing Gel Cream</p>
                </div>
                <div v-if="user.user.language == 'IT' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune<br>Eye</p>
                  <p class="mt-0 text-center font-size-18">Power Infusing Eye<br>Concentrate</p>
                </div>

                <div v-if="user.user.country == 'BX'">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Vital Perfection</p>
                  <p class="mt-0 text-center font-size-18">Uplifting and Firming<br>Day Cream</p>
                </div>
                <div v-if="user.user.country == 'ME'">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune</p>
                  <p class="mt-0 text-center font-size-18">Defense Refresh Mist</p>
                </div>
                <div v-if="user.user.country == 'TX'">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Benefiance</p>
                  <p class="mt-0 text-center font-size-18">Overnight Wrinkle <br> Resisting Cream</p>
                </div>
                <img src="@/assets/gifts/gift_jbl_tt_cx.jpg" class="img-fluid" v-if="user.user.country == 'CX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_ch.jpg" class="img-fluid" v-if="user.user.country == 'CH'  && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_es.jpg" class="img-fluid" v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_fr.jpg" class="img-fluid" v-if="user.user.language == 'FR' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_it.jpg" class="img-fluid" v-if="(user.user.language == 'IT' || user.user.language == 'PL') && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_pt.jpg" class="img-fluid" v-if="user.user.language == 'PT' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_de_1.jpg" class="img-fluid" v-if="user.user.language == 'DE' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">

                <div v-if="user.user.country == 'CH' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune</p>
                  <p class="mt-0 text-center font-size-18">50ml</p>
                </div>
                <div v-if="user.user.language == 'ES' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">FSLX</p>
                  <p class="mt-0 text-center font-size-18">Concentrated<br> Balancing Softener</p>
                </div>
                <div v-if="user.user.language == 'FR' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Vital Perfection</p>
                  <p class="mt-0 text-center font-size-18">Crème Lift Fermeté<br>Jour et Nuit 50 ml</p>
                </div>
                <div v-if="(user.user.language == 'IT' || user.user.language == 'PL') && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune <br>Eye</p>
                  <p class="mt-0 text-center font-size-18">Power Infusing Eye<br>Concentrate</p>
                </div>
                <div v-if="user.user.language == 'PT' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">White Lucent</p>
                  <p class="mt-0 text-center font-size-18">Brightening Gel Cream</p>
                </div>
                <div v-if="user.user.language == 'DE' && user.user.country != 'CH' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">FUTURE SOLUTION LX</p>
                  <p class="mt-0 text-center font-size-12 small" v-html="$t('GIFT_DE_INFO')"></p>
                </div>
                <div v-if="user.user.country == 'CX' && user.user.is_limited_to_lounge == 1">

                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'EN'">We will let you know very soon!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'ES'">¡Se lo haremos saber muy pronto!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'FR'">Nous vous le ferons savoir très bientôt !</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'PL'">Damy ci znać wkrótce!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'DE'">Das werden Sie hier sehr bald erfahren!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'IT'">Vi faremo sapere molto presto!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'RU'">Мы сообщим вам очень скоро!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'NL'">We laten het u binnenkort weten!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'PT'">Informá-lo-emos muito em breve!</p>



                </div>


              </div>
            </div>
          </div>
          <Slick ref="slick" :options="slickOptions2" v-else class="mobile__slider">
            <div class="card bg-red text-white" >
              <div class="card-body d-flex align-items-end justify-content-center flex-column">
                <h2 class="text-uppercase font-black text-right" v-html="$t('MENU06')">How to win a prize</h2>
                <p class="btn btn-white btn-white--chevron-left" v-on:click="menuActive = 1" v-html="$t('MENU_BACK')">back</p>
              </div>
            </div>
            <div class="card">
              <div class="card-body d-flex align-items-center justify-content-center">
                <p v-html="$t('MENU07')">You have three attempts at each quiz. To get the Souvenir Pin you must reach 80% in each quiz, when you have all 3 pins you qualify for a gift</p>
              </div>
            </div>
            <div class="card">
              <div class="card-body d-flex align-items-center justify-content-center flex-column" v-if="user.gift_active != 0">
                <img src="@/assets/gifts/gift_ru.jpg" class="img-fluid" v-if="user.user.language == 'RU' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">

                <img src="@/assets/gifts/gift_uk.jpg" class="img-fluid" v-if="user.user.language == 'EN' && user.user.country != 'TX' && user.user.country !='ME' && user.user.is_limited_to_lounge != 1">
                <img src="@/assets/gifts/gift_es.jpg" class="img-fluid" v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                <img src="@/assets/gifts/gift_it.jpg" class="img-fluid" v-if="user.user.language == 'IT' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                <img src="@/assets/gifts/gift_bx.jpg" class="img-fluid" v-if="user.user.country == 'BX'">
                <img src="@/assets/gifts/gift_me.jpg" class="img-fluid" v-if="user.user.country == 'ME'">
                <img src="@/assets/gifts/gift_tr.jpg" class="img-fluid" v-if="user.user.country == 'TX'">
                <div v-if="user.user.language == 'RU' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">White Lucent</p>
                  <p class="mt-0 text-center font-size-18">Ночная крем-маска</p>
                </div>
                <div v-if="user.user.language == 'EN' && user.user.country != 'TX' && user.user.country != 'ME' && user.user.is_limited_to_lounge != 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Benefiance</p>
                  <p class="mt-0 text-center font-size-18">Wrinkle Smoothing Cream</p>
                </div>
                <div v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Essential Energy</p>
                  <p class="mt-0 text-center font-size-18">Moisturizing Gel Cream</p>
                </div>
                <div v-if="user.user.language == 'IT'  && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune<br>Eye</p>
                  <p class="mt-0 text-center font-size-18">Power Infusing Eye<br>Concentrate</p>
                </div>

                <div v-if="user.user.country == 'BX'">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Vital Perfection</p>
                  <p class="mt-0 text-center font-size-18">Uplifting and Firming<br>Day Cream</p>
                </div>
                <div v-if="user.user.country == 'ME'">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune</p>
                  <p class="mt-0 text-center font-size-18">Defense Refresh Mist</p>
                </div>
                <div v-if="user.user.country == 'TX'">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Benefiance</p>
                  <p class="mt-0 text-center font-size-18">Overnight Wrinkle <br> Resisting Cream</p>
                </div>
                <img src="@/assets/gifts/gift_jbl_tt_cx.jpg" class="img-fluid" v-if="user.user.country == 'CX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_ch.jpg" class="img-fluid" v-if="user.user.country == 'CH' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_es.jpg" class="img-fluid" v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_fr.jpg" class="img-fluid" v-if="user.user.language == 'FR' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_it.jpg" class="img-fluid" v-if="(user.user.language == 'IT' || user.user.language == 'PL') && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_pt.jpg" class="img-fluid" v-if="user.user.language == 'PT'  && user.user.country != 'TX' && user.is_limited_to_lounge == 1">
                <img src="@/assets/gifts/gift_jbl_tt_de_1.jpg" class="img-fluid" v-if="user.user.language == 'DE' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">

                <div v-if="user.user.country == 'CH' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune</p>
                  <p class="mt-0 text-center font-size-18">50ml</p>
                </div>
                <div v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">FSLX</p>
                  <p class="mt-0 text-center font-size-18">Concentrated<br> Balancing Softener</p>
                </div>
                <div v-if="user.user.language == 'FR' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Vital Perfection</p>
                  <p class="mt-0 text-center font-size-18">Crème Lift Fermeté<br>Jour et Nuit 50 ml</p>
                </div>
                <div v-if="(user.user.language == 'IT' || user.user.language == 'PL') && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune <br>Eye</p>
                  <p class="mt-0 text-center font-size-18">Power Infusing Eye<br>Concentrate</p>
                </div>
                <div v-if="user.user.language == 'PT' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">White Lucent</p>
                  <p class="mt-0 text-center font-size-18">Brightening Gel Cream</p>
                </div>
                <div v-if="user.user.language == 'DE' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">FUTURE SOLUTION LX</p>
                  <p class="mt-0 text-center font-size-12 small" v-html="$t('GIFT_DE_INFO')"></p>
                </div>
                <div v-if="user.user.country == 'CX' && user.user.is_limited_to_lounge == 1">

                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'EN'">We will let you know very soon!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'ES'">¡Se lo haremos saber muy pronto!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'FR'">Nous vous le ferons savoir très bientôt !</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'PL'">Damy ci znać wkrótce!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'DE'">Das werden Sie hier sehr bald erfahren!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'IT'">Vi faremo sapere molto presto!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'RU'">Мы сообщим вам очень скоро!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'NL'">We laten het u binnenkort weten!</p>
                  <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'PT'">Informá-lo-emos muito em breve!</p>



                </div>
              </div>
            </div>
          </Slick>
        </div>
      </div>


      <div class="row w-100" v-if="menuActive == 4">
        <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3">
          <div class="card-deck" v-if="windowWidth > 992">
            <div class="card bg-red text-white">
              <div class="card-body d-flex align-items-end justify-content-center flex-column">
                <h2 class="text-uppercase font-black text-right" v-html="$t('MENU08')">How to navigate</h2>
                <p class="btn btn-white btn-white--chevron-left" v-on:click="menuActive = 1" v-html="$t('MENU_BACK')">back</p>
              </div>
            </div>
            <div class="card">
              <div class="card-body d-flex justify-content-center flex-column">
                <p v-html="$t('MENU09')">If your visiting on your
                  laptop, use your arrow or
                  W + S keys.</p>
                <p v-html="$t('MENU10')">If your visiting
                  on your mobile device, you´ll
                  need to use the circular
                  fields on the left and
                  right side to look around
                  and move.</p>
              </div>
            </div>
            <div class="card">
              <div class="card-body d-flex align-items-center justify-content-center flex-column py-6  py-xl-10">
                <div class="row">
                  <div class="col">
                    <div class="box--key">
                      <img src="@/assets/icons/red/arrow-up.svg" class="img-fluid">
                    </div>
                    <div class="box--key">
                      <img src="@/assets/icons/red/arrow-down.svg" class="img-fluid">
                    </div>
                  </div>
                </div>
                <h2 class="text-uppercase font-black my-4" v-html="$t('MENU11')">or</h2>
                <div class="row d-flex flex-row">
                  <div class="col">
                    <div class="box--key" v-html="$t('MENU12')">
                      W
                    </div>
                    <div class="box--key" v-html="$t('MENU13')">
                      S
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Slick ref="slick" :options="slickOptions2" v-else class="mobile__slider">
            <div class="card bg-red text-white">
              <div class="card-body d-flex align-items-end justify-content-center flex-column">
                <h2 class="text-uppercase font-black text-right" v-html="$t('MENU08')">How to navigate</h2>
                <p class="btn btn-white btn-white--chevron-left" v-on:click="menuActive = 1" v-html="$t('MENU_BACK')">back</p>
              </div>
            </div>
            <div class="card">
              <div class="card-body d-flex justify-content-center flex-column">
                <p v-html="$t('MENU09')">If your visiting on your
                  laptop, use your arrow or
                  W + S keys.</p>
                <p v-html="$t('MENU10')">If your visiting
                  on your mobile device, you´ll
                  need to use the circular
                  fields on the left and
                  right side to look around
                  and move.</p>
              </div>
            </div>
            <div class="card">
              <div class="card-body d-flex align-items-center justify-content-center flex-column py-6  py-xl-10">
                <div class="row">
                  <div class="col">
                    <div class="box--key">
                      <img src="@/assets/icons/red/arrow-up.svg" class="img-fluid">
                    </div>
                    <div class="box--key">
                      <img src="@/assets/icons/red/arrow-down.svg" class="img-fluid">
                    </div>
                  </div>
                </div>
                <h2 class="text-uppercase font-black my-4" v-html="$t('MENU11')">or</h2>
                <div class="row d-flex flex-row">
                  <div class="col">
                    <div class="box--key" v-html="$t('MENU12')">
                      W
                    </div>
                    <div class="box--key" v-html="$t('MENU13')">
                      S
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slick>
        </div>
      </div>

      <ul class="ml-0 close__module-wrapper" v-if="menuActive == 1">
        <li class="close__module-btn btn btn-red" v-on:click="closeModule" v-html="$t('GLOBAL_CLOSE')">
          close module
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import $ from "jquery"
import Slick from 'vue-slick';
export default {
  name: "Header",
  components: {
    Slick,
  },
  props:{
    isSafari: false,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      worldStatus: [1, 0, 0],
      progressStatus: [[0,0],[0,0,0,0],[0,0,0,0]],
      quizStatus: [0, 0, 0],
      quizSuccess: [0, 0, 0],
      showMenu: false,
      menuActive: 1,
      howToOpen: false,
      discoverOpen: false,
      user: Object,
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        draggable: false,
        accessibility: false,
        infinite: false,
        vertical: false,
        dots: true,
        swipe: false,
        adaptiveHeight: true
      },
      slickOptions2: {
        slidesToShow: 1,
        arrows: false,
        draggable: false,
        accessibility: false,
        infinite: false,
        vertical: false,
        dots: true,
        swipe: false,
        adaptiveHeight: true
      },
    }
  },
  created() {
    this.$store.watch(
            (state, getters) => getters.moduleStatus,
            (newValue, oldValue) => {
              console.log("From Header: Store Changed get via getters:", this.$store.getters.moduleStatus)
              console.log("From Header: Store Changed get cia newValue:", newValue)
              let moduleStat = this.$store.getters.moduleStatus;
              for (let i = 0; i < moduleStat.length; i++) {
                let key = moduleStat[i];
                switch (key[0]) {
                  case '01':
                    this.worldStatus[1] = 1;
                    break;
                  case '02':
                    this.worldStatus[2] = 1;
                    break;
                  case '01-01':
                    this.progressStatus[0][0] = 1;
                    break;
                  case '01-02':
                    this.progressStatus[0][1] = 1;
                    break;
                  case '02-01':
                    this.progressStatus[1][0] = 1;
                    break;
                  case '02-02':
                    this.progressStatus[1][1] = 1;
                    break;
                  case '02-03':
                    this.progressStatus[1][2] = 1;
                    break;
                  case '02-04':
                    this.progressStatus[1][3] = 1;
                    break;
                  case '03-01':
                    this.progressStatus[2][0] = 1;
                    break;
                  case '03-02':
                    this.progressStatus[2][1] = 1;
                    break;
                  case '03-03':
                    this.progressStatus[2][2] = 1;
                    break;
                  case '03-04':
                    this.progressStatus[2][3] = 1;
                    break;
                }
              }
            }
    ),
            this.$store.watch(
                    (state, getters) => getters.user,
                    (newValue, oldValue) => {
                      let u = this.$store.getters.user;
                      if (typeof u === 'string' || u instanceof String){
                        u = JSON.parse(u)
                      }
                      this.user = u;
                      this.quizSuccess = u.quiz.successful;
                      this.quizStatus = u.quiz.attempts;
                    }
            )
  },
  methods: {
    closeModule() {
      let url;
      if(this.user.user.is_member == 1 && this.user.user.is_douglas == 1 || this.user.user.is_loungeuser == 1){
        url = this.user.exit_url_jbl;

      } else {
        url = this.user.exit_url;
      }
      window.location = 'https://www.discover-shiseido.com'+url;
    },
    openHowTo(){
      this.discoverOpen = false;
      this.howToOpen = !this.howToOpen;
    },
    openDiscover(){
      this.howToOpen = false;
      this.discoverOpen = !this.discoverOpen;
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  mounted() {
    let _this = this;
    let u = this.$store.getters.user;
    if (typeof u === 'string' || u instanceof String){
      u = JSON.parse(u)
    }
    this.user = u;
    this.quizSuccess = u.quiz.successful;
    this.quizStatus = u.quiz.attempts;
    document.body.addEventListener('keypress', function (e) {
      if (e.key == "Escape" || e.key == "Enter") {
        _this.showMenu = !_this.showMenu;
      }
    });
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  watch: {
    showMenu: function (newValue, oldValue) {
      this.menuActive = 1;
      if (newValue == true) {
        $('body').addClass('overflow-hidden');
      } else {
        $('body').removeClass('overflow-hidden');
      }
    },
  },

  computed: {
    landmarks() {
      return [0, 0, 0]
    },
    quizStatusMax() {
      return [1, 1, 1]
    },
    landmarksMax() {
      return [2, 4, 4]
    }
  }

}
</script>

<style scoped>

</style>